import { ApolloError } from '@apollo/client/core';
import { Map } from 'immutable';

export const LOAD_SETTINGS = 'LOAD_SETTINGS';
export const LOAD_SETTINGS_SUCCESS = 'LOAD_SETTINGS_SUCCESS';
export const LOAD_SETTINGS_FAILURE = 'LOAD_SETTINGS_FAILURE';

export interface SettingsState {
  loading: boolean;
  loaded: boolean;
  currentSettings: Map<string, any>;
  error: ApolloError;
}

const initialState: SettingsState = {
  loading: false,
  loaded: false,
  currentSettings: null,
  error: null,
};

export function settingsReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOAD_SETTINGS:
      return Object.assign({}, state, {
        loading: true,
      });

    case LOAD_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        currentSettings: action.payload,
        error: null,
      });

    case LOAD_SETTINGS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload,
      });

    default:
      return state;
  }
}
